// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Kw1o","col":"styles_col__1S8DA"};